import { TAO_KOE } from './../libs';

const tabbableElementsSelector = 'a[href]';

/**
 * Menu Class
 *
 * @param {string} target
 */
class MenuKeyboard {
	constructor( containerEl ) {
		this.containerEl = containerEl;
		this.containerEl.addEventListener( 'keydown', ( ev ) => {
			if ( 9 === ev.keyCode ) {
				this.onTabKeyDown( ev );
			}
		} );
	}

	onTabKeyDown( ev ) {
		// Hijack Tab Key on Menu Item.
		if ( ev.target.closest( '.mdl_mainmenu__root-item' ) ) {
			const currentSubmenuEl = this.containerEl.querySelector( '.mdl_mainmenu__sub-ul.is-active' );
			if ( ! ev.shiftKey ) {
				const firstNextLinkEl = currentSubmenuEl && currentSubmenuEl.querySelector( tabbableElementsSelector );
				if ( firstNextLinkEl ) {
					ev.preventDefault();
					firstNextLinkEl.focus();
				}
			} else {
				const lastPrevLinkEl = currentSubmenuEl && currentSubmenuEl.previousElementSibling && currentSubmenuEl.previousElementSibling.querySelector( tabbableElementsSelector );
				if ( lastPrevLinkEl ) {
					ev.preventDefault();
					lastPrevLinkEl.focus();
				}
			}
		} else {
			// Hijack Tab Key in submenu.
			const subEl = ev.target.closest( '.mdl_mainmenu__sub-ul' );
			if ( subEl ) {
				const linkEls = Array.from( subEl.querySelectorAll( tabbableElementsSelector ) );
				const firstLinkEl = linkEls[ 0 ] ?? null;
				const lastLinkEl = linkEls[ linkEls.length - 1 ] ?? null;
				if ( ev.target === lastLinkEl && ! ev.shiftKey ) {
					const currentMenuEl = this.containerEl.querySelector( '.mdl_mainmenu__root-item[data-nav="' + subEl.dataset.nav + '"]' );
					const nextLinkEl = currentMenuEl && currentMenuEl.nextElementSibling && currentMenuEl.nextElementSibling.querySelector( tabbableElementsSelector );
					if ( nextLinkEl ) {
						ev.preventDefault();
						nextLinkEl.focus();
					}
				} else if ( ev.target === firstLinkEl && ev.shiftKey ) {
					const currentMenuEl = this.containerEl.querySelector( '.mdl_mainmenu__root-item[data-nav="' + subEl.dataset.nav + '"]' );
					const prevLinkEl = currentMenuEl && currentMenuEl.querySelector( tabbableElementsSelector );
					if ( prevLinkEl ) {
						ev.preventDefault();
						prevLinkEl.focus();
					}
				}
			}
		}
	}
}

/**
 * Initialise.
 *
 * @param {Document|Element} scopeEl Scope to search for menu.
 */
const initMenuKeyboard = function( scopeEl = document ) {
	if ( TAO_KOE.MenuDisable ) {
		return;
	}

	// Initialise Mainmenu.
	const containerEls = scopeEl.querySelectorAll( '.mdl_mainmenu' );
	containerEls.forEach( ( containerEl ) => {
		containerEl.KOE_MENU_KEYBOARD ??= new MenuKeyboard( containerEl );
	} );
};

// Init.
TAO_KOE.ready( 'menu-keyboard.js', () => initMenuKeyboard() );

export {
	MenuKeyboard as default,
	MenuKeyboard,
	initMenuKeyboard,
};
